import React, { useContext, useState, createContext } from 'react'

const SimulatedMarginContext = createContext({})

export function SimulatedMarginProvider({ children }) {
  const [hasSimulatedMargin, setHasSimulatedMargin] = useState(false)
  const [isSimulatedMarginValid, setIsSimulatedMarginValid] = useState(true)
  const [invalidMarginMessage, setInvalidMarginMessage] = useState('')
  const [isRequestedMarginLoading, setIsRequestedMarginLoading] = useState(false)

  const [availableMarginProjection, setAvailableMarginProjection] = useState([])

  const [displayProjectedMargin, setDisplayProjectedMargin] = useState(null)

  function handleMarginSimulate(value) {
    setHasSimulatedMargin(value)
  }

  function handleSimulatedMarginValidation(isValid) {
    setIsSimulatedMarginValid(isValid)
  }

  function marginValidation(isValidMargin, validationMessage, setFieldTouched, field = 'margemSolicitada') {
    handleSimulatedMarginValidation(isValidMargin)
    if (!isValidMargin) {
      setInvalidMarginMessage(validationMessage)
      setFieldTouched && setFieldTouched(field, true)
      return
    }

    setInvalidMarginMessage('')
    setFieldTouched && setFieldTouched(field, false)
  }

  function calculatingMarginLoadingStatus(isCalculating) {
    setIsRequestedMarginLoading(isCalculating)
  }

  function handleAvailableMarginProjection(marginProjection) {
    const filteredProjection = marginProjection.map(projection => {
      return {
        margemDisponivel: projection.valor || projection.margemDisponivel || 0,
        month: projection.mes || projection.month,
        year: projection.ano || projection.year,
        valorProjetadoNegativo: projection.valorProjetadoNegativo || false,
        valorProjetado: projection.valorProjetado || false
      }
    })

    setAvailableMarginProjection(filteredProjection)
  }

  function validateFutureMargin(margens) {
    const isValid = margens.every(margem => margem.valorProjetadoNegativo === false)

    return isValid
  }

  function validateCurrentMargin(margens) {
    const isValid = margens && margens[0].valorProjetadoNegativo === false

    return isValid
  }

  function resetFormValidationStates() {
    handleMarginSimulate(false)
    handleSimulatedMarginValidation(true)
    setInvalidMarginMessage('')
    setDisplayProjectedMargin(null)
    setIsRequestedMarginLoading(false)
  }

  function handleMarginProjectionDisplay() {
    setDisplayProjectedMargin(displayProjectedMargin !== false ? false : true)
  }

  return (
    <SimulatedMarginContext.Provider
      value={{
        handleMarginSimulate,
        hasSimulatedMargin,
        marginValidation,
        isSimulatedMarginValid,
        invalidMarginMessage,
        calculatingMarginLoadingStatus,
        isRequestedMarginLoading,
        handleAvailableMarginProjection,
        availableMarginProjection,
        validateFutureMargin,
        validateCurrentMargin,
        resetFormValidationStates,
        displayProjectedMargin,
        handleMarginProjectionDisplay,
        setDisplayProjectedMargin
      }}
    >
      {children}
    </SimulatedMarginContext.Provider>
  )
}

export function useSimulatedMargin() {
  const context = useContext(SimulatedMarginContext)

  return context
}
